import { useEffect, type ReactNode } from 'react';
import { applyTheme, darkModeMediaQuery, useThemeStore } from '@/lib/theme';

interface ThemeProviderProps {
	children: ReactNode;
}

/** Keeps the document theme in sync with the stored preference. */
export function ThemeProvider({ children }: ThemeProviderProps) {
	const theme = useThemeStore((state) => state.theme);

	useEffect(() => {
		applyTheme(theme);

		if (theme !== 'system') {
			return;
		}

		// Follow OS changes while the preference is "system".
		const media = window.matchMedia(darkModeMediaQuery);
		const handleChange = () => applyTheme('system');
		media.addEventListener('change', handleChange);

		return () => media.removeEventListener('change', handleChange);
	}, [theme]);

	return <>{children}</>;
}
